import React from 'react';
import { X } from 'lucide-react';
interface BaseDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
  width?: 'sm' | 'md' | 'lg';
}
const BaseDrawer: React.FC<BaseDrawerProps> = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  footer,
  width = 'md'
}) => {
  if (!isOpen) return null;
  const widthClasses = {
    sm: 'w-full sm:w-[400px]',
    md: 'w-full sm:w-[500px]',
    lg: 'w-full sm:w-[600px]'
  };
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={onClose} data-id="element-574" />

      {/* Drawer */}
      <div className={`fixed top-0 right-0 h-full ${widthClasses[width]} bg-white shadow-2xl z-50 overflow-y-auto transition-transform duration-300 ease-in-out ${isOpen ? 'transform-none' : 'translate-x-full'}`} data-id="element-575">
        <div className="p-6" data-id="element-576">
          {/* Header */}
          <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-200" data-id="element-577">
            <div data-id="element-578">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-579">{title}</h2>
              {description && <p className="text-sm text-gray-600 mt-1" data-id="element-580">{description}</p>}
            </div>
            <button onClick={onClose} className="rounded-full p-2 hover:bg-gray-100 transition-colors" data-id="element-581">
              <X className="h-5 w-5 text-gray-500" data-id="element-582" />
            </button>
          </div>

          {/* Body */}
          <div className="space-y-6" data-id="element-583">{children}</div>

          {/* Footer */}
          {footer && <div className="mt-8 pt-6 border-t border-gray-200" data-id="element-584">{footer}</div>}
        </div>
      </div>
    </>;
};
export default BaseDrawer;